import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import DirectionsIcon from "@mui/icons-material/Directions";
import { db } from "../../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import ok from "../../assets/sound/ok.mp3";
import err from "../../assets/sound/error.mp3";
import { CalendarMonth, Money } from "@mui/icons-material";
import { Box } from "@mui/material";

const Settings = () => {
  const [fixed, setFixed] = useState(0);
  const [dateChart, setDateChart] = useState("");
  const [dateStat, setDateStat] = useState("");
  var fx = 0;
  var idx = "";
  var dc = "";
  var newFields = {};
  useEffect(() => {
    const globalx = async () => {
      const q = query(collection(db, "global1"));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        fx = doc.data().fixedCost;
        dc = doc.data().dateChart;
      });
      setFixed(fx);
      setDateChart(dc);
    };

    globalx();
  }, []);

  const handleEnter = async () => {
    const userDoc = doc(db, "global1", "base");
    const newFields = { fixedCost: fixed, dateChart: dateChart };
    try {
      await updateDoc(userDoc, newFields);
      new Audio(ok).play();
    } catch (e) {
      console.log("ERROR", e);
      new Audio(err).play();
    }
  };

  const handleStockToTotal = async () => {
    const ref = collection(db, "products");
    const querySnapshot = await getDocs(ref);
    querySnapshot.forEach((doc) => {
      var store = Number(doc.data().stock_store);
      var van = Number(doc.data().stock_van);
      var web = Number(doc.data().stock_var1);
      var amazon = Number(doc.data().stock_var2);
      var total = store + van + web + amazon;
      const docId = doc.id;
      updateStockTotal(docId, total);
    });
    new Audio(ok).play();
  };

  const handleProductStat = async () => {
    const productRef = collection(db, "products");

    const querySnapshot = await getDocs(productRef);
    querySnapshot.forEach((doc) => {
      const docId = doc.id;
      queryProductStat(docId);
    });

    new Audio(ok).play();
  };

  const queryProductStat = (docId) => {
    monthStat("01", docId);
  };

  const monthStat = async (mm, id) => {
    const d001 = "d" + dateStat + "01";
    const d002 = "d" + dateStat + "02";
    const d003 = "d" + dateStat + "03";
    const d004 = "d" + dateStat + "04";
    const d005 = "d" + dateStat + "05";
    const d006 = "d" + dateStat + "06";
    const d007 = "d" + dateStat + "07";
    const d008 = "d" + dateStat + "08";
    const d009 = "d" + dateStat + "09";
    const d010 = "d" + dateStat + "10";
    const d011 = "d" + dateStat + "11";
    const d012 = "d" + dateStat + "12";
    const docRefId = doc(db, "productStat", id);
    const docSnap = await getDoc(docRefId);
    if (docSnap.exists()) {
      console.log("exists");
    } else {
      await setDoc(doc(db, "productStat", id), {
        [d001]: 0,
        [d002]: 0,
        [d003]: 0,
        [d004]: 0,
        [d005]: 0,
        [d006]: 0,
        [d007]: 0,
        [d008]: 0,
        [d009]: 0,
        [d010]: 0,
        [d011]: 0,
        [d012]: 0,
      });
    }
  };

  const updateStockTotal = async (doctId, total) => {
    console.log(total);
    const userDoc = doc(db, "products", doctId);
    const newFields = { stock_all: total };
    await updateDoc(userDoc, newFields);
  };

  return (
    <>
      <AppBar
        position="absolute"
        color="default"
        elevation={0}
        sx={{
          position: "relative",
          borderBottom: (t) => `1px solid ${t.palette.divider}`,
        }}
      >
        <Toolbar>
          <Typography variant="h6" color="inherit" noWrap>
            Settings
          </Typography>
        </Toolbar>
      </AppBar>
      <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
        <Paper
          variant="outlined"
          sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
        >
          <React.Fragment>
            <Typography variant="caption">Fixed Cost</Typography>
            <Paper
              component="form"
              fullWidth
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <IconButton sx={{ p: "10px" }} aria-label="menu">
                <Money />
              </IconButton>
              <InputBase
                aria-label="fixed cost"
                fullWidth
                onChange={(e) => {
                  setFixed(e.target.value);
                }}
                value={fixed}
                sx={{ ml: 1, flex: 1 }}
                placeholder="Fixed Cost"
                inputProps={{ "aria-label": "search google maps" }}
              />

              <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
              <IconButton
                color="primary"
                sx={{ p: "10px" }}
                aria-label="directions"
                onClick={handleEnter}
              >
                <DirectionsIcon />
              </IconButton>
            </Paper>
            <Typography variant="caption">{idx}</Typography>
          </React.Fragment>
          <React.Fragment>
            <Typography variant="caption">Chart Date</Typography>
            <Paper
              component="form"
              fullWidth
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <IconButton sx={{ p: "10px" }} aria-label="menu">
                <CalendarMonth />
              </IconButton>
              <InputBase
                aria-label="date Chart"
                fullWidth
                onChange={(e) => {
                  setDateChart(e.target.value);
                }}
                value={dateChart}
                sx={{ ml: 1, flex: 1 }}
                placeholder="date Chart format : YYYY-MM"
                inputProps={{ "aria-label": "search google maps" }}
              />

              <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
              <IconButton
                color="primary"
                sx={{ p: "10px" }}
                aria-label="directions"
                onClick={handleEnter}
              >
                <DirectionsIcon />
              </IconButton>
            </Paper>
            <Typography variant="caption">{idx}</Typography>
          </React.Fragment>
        </Paper>
        <Paper>
          <Box>
            <IconButton
              onClick={handleStockToTotal}
              color="secondary"
              sx={{ p: "10px" }}
            >
              <Typography variant="caption">
                Sum all locations to stock_all ...{"   "}
              </Typography>{" "}
              <DirectionsIcon />
            </IconButton>
          </Box>
        </Paper>
        <React.Fragment>
          <Typography variant="caption">Product Stat setup</Typography>
          <Paper
            component="form"
            fullWidth
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconButton sx={{ p: "10px" }} aria-label="menu">
              <CalendarMonth />
            </IconButton>
            <InputBase
              aria-label="date Chart"
              fullWidth
              onChange={(e) => {
                setDateStat(e.target.value);
              }}
              value={dateStat}
              sx={{ ml: 1, flex: 1 }}
              placeholder="Product Stat enter year : YYYY"
              inputProps={{ "aria-label": "search google maps" }}
            />

            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton
              color="primary"
              sx={{ p: "10px" }}
              aria-label="directions"
              onClick={handleProductStat}
            >
              <DirectionsIcon />
            </IconButton>
          </Paper>
          <Typography variant="caption">{idx}</Typography>
        </React.Fragment>
      </Container>
    </>
  );
};

export default Settings;
